import { IReturn, ReturnList } from "@/interfaces/Return";
import {
  getDeliveryCanceledReturns,
  getDeliveryReturns,
  getExpeditionReturns,
  getHubReturns,
  getSellerReturns,
  getWarehouseReturns,
  Payload,
} from "../services/return-list.service";
import { AxiosResponse } from "axios";
import { ServerResponse_ } from "@/interfaces/Server";
import { Roles } from "@/enums";

export const fetchReturnList = async (
  roles: string,
  payload: Payload
): Promise<IReturn[]> => {
  const roleMap: {
    [key: string]: () => Promise<
      AxiosResponse<ServerResponse_<ReturnList>> | undefined
    >;
  } = {
    [Roles.SELLER_ROLE]: () => getSellerReturns(payload),
    [Roles.DELIVERY_ROLE]: () => getDeliveryReturns(payload),
    [Roles.WAREHOUSE_ROLE]: () => getWarehouseReturns(payload),
    [Roles.HUB_ROLE]: () => getHubReturns(payload),
    [Roles.EXPEDITION_ROLE]: () => getExpeditionReturns(payload),
  };

  let fetchFunction = null;

  if (roles.includes(Roles.WAREHOUSE_ROLE)) {
    fetchFunction = roleMap[Roles.WAREHOUSE_ROLE];
  } else if (roles.includes(Roles.DELIVERY_ROLE)) {
    fetchFunction = roleMap[Roles.DELIVERY_ROLE];
  } else if (roles.includes(Roles.SELLER_ROLE)) {
    fetchFunction = roleMap[Roles.SELLER_ROLE];
  } else if (roles.includes(Roles.HUB_ROLE)) {
    fetchFunction = roleMap[Roles.HUB_ROLE];
  } else if (roles.includes(Roles.EXPEDITION_ROLE)) {
    fetchFunction = roleMap[Roles.EXPEDITION_ROLE];
  }

  if (!fetchFunction) {
    return [];
  }

  try {
    const response = await fetchFunction();
    return response?.data.data.list ?? [];
  } catch {
    return [];
  }
};

export const fetchCancellationReturnList = async (
  payload: Payload
): Promise<IReturn[]> => {
  try {
    const response = await getDeliveryCanceledReturns(payload);
    return response?.data.data.list ?? [];
  } catch {
    return [];
  }
};
